import React from 'react';

function Footer() {
    return (
        <header style={headerStyle}> Happy shopping! </header> 
    )
}

const headerStyle = {
    background: '#51A6A6',
    color: '#fff',
    textAlign: 'center',
    padding: '30px'
}


export default Footer